import { render, staticRenderFns } from "./my-statistics.vue?vue&type=template&id=71ed5989&scoped=true&"
import script from "./my-statistics.vue?vue&type=script&lang=js&"
export * from "./my-statistics.vue?vue&type=script&lang=js&"
import style0 from "./my-statistics.vue?vue&type=style&index=0&id=71ed5989&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed5989",
  null
  
)

export default component.exports